export const REGISTER_PATH = '/register'
export const LOGIN_PATH = '/login'
export const FORGOTTEN_PASSWORD_PATH = '/forgotten-password'
export const LANDING_PATH = '/'
export const PAYMENT_SUCCESSFUL_PATH = '/payment-successful'
export const ACTIVATE_EMAIL_PATH = '/active-email'
